import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/haha.vue'),
    meta: {
      title: '省的多 本地线上超市'
    }
  },
  {
    path: '/haha',
    name: 'haha',
    component: () => import('../views/haha.vue'),
    meta: {
      title: '省的多 本地线上超市'
    }
  },
  {
    path: '/store/receipt',
    name: 'store_receipt',
    component: () => import('../views/receipt.vue'),
    meta: {
      title: '省的多'
    }
  },
  {
    path: '/official/success',
    name: 'official_success',
    component: () => import('../views/official_success.vue'),
    meta: {
      title: '订阅成功'
    }
  },
  {
    path: '/official/error',
    name: 'official_error',
    component: () => import('../views/official_error.vue'),
    meta: {
      title: '订阅失败'
    }
  },
  {
    path: '/store/groupon',
    name: 'store_groupon',
    component: () => import('../views/groupon.vue'),
    meta: {
      title: '省的多'
    }
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    component: () => import('../views/cooperation.vue'),
    meta: {
      title: '合作加盟'
    }
  }

]

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
